import { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";

import SuspenseLoader from "src/components/SuspenseLoader";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Users = Loader(lazy(() => import("src/content/users")));

const userRoutes = [
  {
    path: "/",
    element: (
      <>
        <Helmet>
          <title> Kullanıcılar </title>
        </Helmet>
        <Users />
      </>
    ),
  },
];

export default userRoutes;
